import { render } from "./ChangeThinkingDialog.vue?vue&type=template&id=acf3aa4e"
import script from "./ChangeThinkingDialog.vue?vue&type=script&lang=js"
export * from "./ChangeThinkingDialog.vue?vue&type=script&lang=js"

import "./ChangeThinkingDialog.vue?vue&type=style&index=0&id=acf3aa4e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__